/* global process */
let base = window._env_.VUE_APP_ADMIN_HOST

export const getGroupBatchTable = params => {
  return axios.post(`${base}/group-batch/query`, params)
}
export const getGroupBatchDetail = params => {
  return axios.get(`${base}/group-batch/get_${params.id}`, {params})
}
export const createGroupBatchData = params => {
  return axios.post(`${base}/group-batch/create`, params)
}
export const updateGroupBatchData = params => {
  return axios.post(`${base}/group-batch/edit_${params.id}`, params)
}
export const getGroupBatchTargetNumTable = params => {
  return axios.post(`${base}/group-batch/target_number_${params.id}`, params)
}

export const updateGroupBatchTargetNum = params => {
  return axios.post(`${base}/group-batch/update_target_number_${params.id}`, params)
}

export const getGroupBatchRelationMarkets = params => {
  return axios.post(`${base}/group-batch/relation_markets_${params.id}`, params)
}

export const getGroupBatchRelationTasks = params => {
  return axios.post(`${base}/group-batch/relation_tasks_${params.id}`, params)
}

export const getTaskGroupEventQueueStatus = params => {
  return axios.get(`${base}/group-batch/task_group_event_queue_status`, {params})
}

export const openTaskGroupBySearch = params => {
  return axios.post(`${base}/batch_jobs/open_task_group_by_search`, params)
}

export const closeTaskGroupBySearch = params => {
  return axios.post(`${base}/batch_jobs/close_task_group_by_search`, params)
}

export const getGroupBatchLogTable = params => {
  return axios.post(`${base}/group-batch/query_log_${params.id}`, params)
}

export const batchOpenGroupBatch = params => {
  return axios.post(`${base}/group-batch/open_group`, params)
}

export const batchCloseGroupBatch = params => {
  return axios.post(`${base}/group-batch/close_group`, params)
}

export const getGroupMarketTable = params => {
  return axios.post(`${base}/group-batch/group_markets/query`, params)
}
export const createGroupMarket = params => {
  return axios.post(`${base}/group-batch/group_markets/create`, params)
}
export const deleteGroupBatchByCustomerId = params => {
  return axios.post(`${base}/group-batch/group_markets/delete_by_customerid`, params)
}
export const updateGroupMarket = params => {
  return axios.post(`${base}/group-batch/group_markets/update_${params.id}`, params)
}
export const importMarketGroupRelation = params => {
  return axios.post(`${base}/batch_jobs/import_market_group_relation`, params)
}
export const giveupMarketGroupRelationConflictApi = params => {
  return axios.post(`${base}/batch_jobs/giveup_market_group_relation_conflict_${params.id}`)
}
export const retryMarketGroupRelationConflictApi = params => {
  return axios.post(`${base}/batch_jobs/retry_market_group_relation_conflict_${params.id}`)
}
export const importMarketGroupTargetNum = params => {
  return axios.post(`${base}/batch_jobs/import_target_number`, params)
}
export const importMarketGroupTargetNumStatus = params => {
  return axios.post(`${base}/batch_jobs/import_target_number_status`, params)
}

export const editTaskLimitStatus = (id, status) => {
  return axios.post(`${base}/group-batch/switch_redundant_taskcnt_restrict_${id}`, status)
}



// WEBPACK FOOTER //
// ./src/views/group-batch/group-batch.api.js